import React, { Component } from "react";
import { Link } from "react-router-dom";

class Cta extends Component {
    render() {
        return (
            <section className="section cm-cta bg-cover" style={{backgroundImage: "url(assets/images/corrected_green_image.png)"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-5 col-lg-6 col-md-8">
                            <div className="text-white">
                                <h2 className="h1 mb-20">Quality Repairs and Services From a Team You Can Trust.</h2>
                                <h3 className="mb-30">Just Give Us a Call at</h3>
                                <h4 className="mb-30">(843) 900-4668 to get started.</h4>
                            </div>
                            <Link to={'/contact'} className="btn btn-light initiate-scripts">Get In Touch!</Link>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-8">
                            <img className="cta-img" style={{width: "100%", height: "auto", objectFit: "contain"}} src={process.env.PUBLIC_URL + '/assets/images/teambanner.jpeg'} alt="" />
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Cta;